import React from 'react';
import { AnimeCard } from './AnimeCard';
import { motion } from 'framer-motion';
const MATCHES = [{
  title: 'Attack on Titan',
  image: 'https://images.unsplash.com/photo-1599839619722-39751411ea63?q=80&w=2000&auto=format&fit=crop',
  match: 97,
  episodes: '89 Episodes',
  genres: ['Dark Fantasy', 'Action', 'Drama']
}, {
  title: "Frieren: Beyond Journey's End",
  image: 'https://images.unsplash.com/photo-1518709268805-4e9042af9f23?q=80&w=2000&auto=format&fit=crop',
  match: 94,
  episodes: '28 Episodes',
  genres: ['Adventure', 'Fantasy', 'Slice of Life']
}, {
  title: 'Spy x Family',
  image: 'https://images.unsplash.com/photo-1607604276583-eef5d076aa5f?q=80&w=2000&auto=format&fit=crop',
  match: 91,
  episodes: '37 Episodes',
  genres: ['Action', 'Comedy', 'Espionage']
}];
export function AiMatch() {
  return <section className="pb-12" data-id="element-12">
      <motion.div initial={{
      opacity: 0
    }} animate={{
      opacity: 1
    }} transition={{
      delay: 0.3
    }} className="mb-6 flex items-center gap-4" data-id="element-13">
        <div className="h-[1px] flex-1 bg-gradient-to-r from-white/10 to-transparent" data-id="element-14" />
        <p className="text-white/50 text-sm italic font-serif" data-id="element-15">
          "Matches your love of slow-burn emotional payoffs"
        </p>
        <div className="h-[1px] flex-1 bg-gradient-to-l from-white/10 to-transparent" data-id="element-16" />
      </motion.div>

      <div className="grid grid-cols-1 gap-6" data-id="element-17">
        {MATCHES.map((anime, idx) => <AnimeCard key={anime.title} {...anime} delay={0.4 + idx * 0.1} data-id="element-18" />)}
      </div>
    </section>;
}